
import React from "react";
import axios from 'axios';
import { connect } from "react-redux";
import './menu.css';
import { Link } from "react-router-dom";
import { store } from "../../redux/store";
import history from "../../auth/history";
import { setAepsSection, setPayTMAepsSection } from "../../redux/aeps/aeps.action";
import tokenErrorHandler from "../tokenErrorHandler";
import { setAepsShow, setBillPayShow, setDMTShow, setKycShow, setPayoutShow, setRechargeShow, setRetailerBalanceVal } from "../../redux/misc-data/misc-data.action";
import menuShow from "./menuShow";
const httpClient = axios.create();

class Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            password: '',
            otpRef: '',
            message: '',
            retailerBalance: 0,
            dmtShow: this.props.dmtShow,
            billPayShow: this.props.billpayshow,
            rechargeShow: this.props.rechargeShow,
            aepsShow: this.props.aepsShow,
            kycShow: this.props.kycShow,
            payOutShow: this.props.payoutShow
        }
    }

    componentDidMount() {
        // alert(this.props.menuVal)

        var menuVal = this.props.menuVal;
        var service = menuVal.split(":")[1];
        var showall = menuVal.split(":")[0];
        
        if (showall == 'true') {
            this.loadMenu();
            setInterval(() => {
                this.loadMenu();
            }, 10000);
        } else {
            if (service == '' || service == 'dmt') {
                setInterval(() => {
                    var menus = menuShow.getMenu();
                    if (menus.dmtShow != this.props.dmtShow) {
                        store.dispatch(setDMTShow(menus.dmtShow))
                    }
                }, 10000);
            }
            if (service == 'mobile' || service == 'recharge') {
                setInterval(() => {
                    var menus = menuShow.getMenu();
                    if (menus.rechargeShow != this.props.rechargeShow) {
                        store.dispatch(setRechargeShow(menus.rechargeShow))
                    }
                }, 10000);
            }
            if (service == 'billpay') {
                setInterval(() => {
                    var menus = menuShow.getMenu();
                    if (menus.billPayShow != this.props.billpayshow) {
                        store.dispatch(setBillPayShow(menus.billPayShow))
                    }
                }, 10000);
            }
            if (service == 'aeps') {
                setInterval(() => {
                    var menus = menuShow.getMenu();
                    if (menus.aepsShow != this.props.aepsShow) {
                        store.dispatch(setAepsShow(menus.aepsShow))
                    }
                    if (menus.kycShow != this.props.kycShow) {
                        store.dispatch(setKycShow(menus.kycShow))
                    }
            
                }, 10000);
            }
            if (service == 'payout') {
                setInterval(() => {
                    var menus = menuShow.getMenu();
                    if (menus.payOutShow != this.props.payoutShow) {
                        store.dispatch(setPayoutShow(menus.payOutShow))
                    }
                    if (menus.kycShow != this.props.kycShow) {
                        store.dispatch(setKycShow(menus.kycShow))
                    }
            
                }, 10000);
            }
        }


        if (this.props.retailerBalanceShow == 'yes') {
            this.loadRetailerBalance();
        }

    }
    componentWillUnmount() {
    }

    loadMenu() {
        var menus = menuShow.getMenu();

        //console.log('checking menus fow status...'+JSON.stringify(menus))
        this.setState({
            dmtShow: menus.dmtShow
        })

        if (menus.dmtShow != this.props.dmtShow) {
            store.dispatch(setDMTShow(menus.dmtShow))
        }

        this.setState({
            billPayShow: menus.billPayShow
        })

        if (menus.billPayShow != this.props.billpayshow) {
            store.dispatch(setBillPayShow(menus.billPayShow))
        }

        this.setState({
            rechargeShow: menus.rechargeShow
        })

        if (menus.rechargeShow != this.props.rechargeShow) {
            store.dispatch(setRechargeShow(menus.rechargeShow))
        }

        this.setState({
            aepsShow: menus.aepsShow
        })

        if (menus.aepsShow != this.props.aepsShow) {
            store.dispatch(setAepsShow(menus.aepsShow))
        }

        this.setState({
            kycShow: menus.kycShow
        })

        if (menus.kycShow != this.props.kycShow) {
            store.dispatch(setKycShow(menus.kycShow))
        }

       
        this.setState({
            payOutShow: menus.payOutShow
        })
        if (menus.payOutShow != this.props.payoutShow) {
            store.dispatch(setPayoutShow(menus.payOutShow))
        }
    }

    goToAeps = (e) => {
        e.preventDefault();
        store.dispatch(setAepsSection('txnHistory'));

        setTimeout(() => {
            var gotoAepsBtn = document.getElementById('gotoAepsBtn');
            gotoAepsBtn.click();
        }, 400);
    }

    loadRetailerBalance = () => {

  
            var url = '/api/v1/account/balance/';
            const headers = {
                'Authorization': 'Bearer ' + this.props.token,
                'client-id': this.props.agentInfo.id,
                'role': this.props.clientRole
            }
            httpClient.get(url + this.props.agentInfo.id, { headers }
            ).then((response) => {
                if (response.data.response.success == true) {
                    var retailerBalanceVal = response.data.balance + response.data.creditLimit -
                        response.data.lien;
                    this.setState({
                        retailerBalance: retailerBalanceVal
                    })
                    store.dispatch(setRetailerBalanceVal(retailerBalanceVal));

                }
            }).catch(error => {
                if (error.message.includes("401")) {
                    tokenErrorHandler.tokenErrorHandle('error', this.props.callBackUrl)
                }
            });
     

    }
    goToAccountHistory = () => {
        var goToAccountHistory = document.getElementById('goToAccountHistory');
        goToAccountHistory.click();
    }

    goToAepsNew = (e) => {
        e.preventDefault();
        store.dispatch(setPayTMAepsSection('txnHistory'));
        setTimeout(() => {
            history.push('/aeps-register');
            history.go();
        }, 300);

           setTimeout(() => {
            history.push('/aeps-register');
            history.go();
          }, 300);
    }

    render() {


        return (


            <div class="menu">
                <Link to='/account-history'>
                    <button id='goToAccountHistory' hidden={true}></button>
                </Link>
                <ul>
                    {this.props.dmtShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'dashBoard' && 'active'}>
                            <Link to='/dmt'>
                                <button type="button"><i class="bank"></i> Money Transfer</button>
                            </Link>

                        </li>
                    }
                    {/* {this.state.billPayShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'billPay' && 'active'}>
                            <Link to='/billPay'>
                                <button type="button" ><i class="bbps"></i> Bill Payment</button>
                            </Link>
                        </li>} */}

                    {this.props.rechargeShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'recharge' && 'active'}>
                            <Link to='/recharge'>
                                <button type="button" ><i class="recharge"></i> Recharge</button>
                            </Link>
                        </li>
                    }


                    {this.props.payoutShow== 'yes' &&

                        <li class={this.props.selectedMenuItem == 'merchant-payout' && 'active'}>
                            <Link to='/merchant-payout'>
                                <button type="button" ><i class="merchant"></i> Merchant Payout</button>
                            </Link>
                        </li>
                    }
                    {this.props.aepsShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'aeps' && 'active'}>

                            <button type="button" onClick={this.goToAeps} ><i class="aeps"></i> AePS</button>

                        </li>
                    }
                      {/* {this.state.aepsShow == 'yes' &&
                        <li class={this.props.selectedMenuItem == 'aeps' && 'active'}>

                            <button type="button" onClick={this.goToAepsNew} ><i class="aeps"></i> AePS-New</button>

                        </li>
                    } */}

                    {this.props.kycShow == 'yes' &&

                        <li class={this.props.selectedMenuItem == 'kyc' && 'active'}>
                            <Link to='/merchant-onboard'>
                                <button type="button" ><i class="comsts"></i> Kyc</button>
                            </Link>
                        </li>
                    }


                    <Link to='/aeps'>
                        <button id='gotoAepsBtn' hidden={true} ></button>
                    </Link>
                    <Link to='/aeps-register'>
                        <button id='gotoAepsPayTMBtn' hidden={true} ></button>
                    </Link>

                    {this.props.retailerBalanceShow == 'yes' &&
                        <div class="tamnt">
                            <i class="ta" onClick={this.goToAccountHistory}>
                            </i> ₹ {parseFloat(this.props.retailerBalanceVal)}
                            <Link to='/claim-upload'>
                                <button type="button" class="btn dbbtn">Claim</button>
                            </Link>
                        </div>
                    }
                </ul>

            </div>
        );
    }
}

const mapStateToProps = ({ errorMessageReduce: { errorMessage, loginErrorMessage },
    miscReduce: { phone, agentInfo, token, loginTime, partner,
        logoName, retailerBalanceShow,
        billpayshow,
        rechargeShow,
        aepsShow,
        dmtShow,
        payoutShow,
        kycShow,
        retailerBalanceVal,
        menuVal }
    , authReduce: { callBackUrl } }
) => ({
    errorMessage, loginErrorMessage, phone, agentInfo, token, loginTime, partner,
    logoName,
    retailerBalanceShow,
    billpayshow,
    rechargeShow,
    aepsShow,
    dmtShow,
    payoutShow,
    kycShow,
    retailerBalanceVal,
    menuVal,
    callBackUrl
});

export default connect(mapStateToProps, null)(Menu);